import React, { useState, useEffect, useRef } from "react";
import kanactifyCarnivalPoster from './ClientLogos/Kanactify-PR-Poster-(CARNIVAL).png';



const RevealContent = ({ children, className = "", delay = 0, style = {} }) => {
  const ref = useRef();
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    const observer = new IntersectionObserver(
      entries => { entries.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); observer.unobserve(el); } }); },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, [delay]);
  return (
    <div ref={ref} className={className} style={{transition:"opacity 900ms cubic-bezier(0.4,0,0.2,1), transform 900ms cubic-bezier(0.4,0,0.2,1)",opacity:on?1:0,transform:on?"translateY(0)":"translateY(60px)",...style}}>
      {children}
    </div>
  );
};

const RevealLine = ({ children, delay = 0, style = {} }) => {
  const ref = useRef();
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    const observer = new IntersectionObserver(
      entries => { entries.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); observer.unobserve(el); } }); },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, [delay]);
  return (
    <div ref={ref} style={{overflow:"hidden",...style}}>
      <div style={{transition:"transform 1000ms cubic-bezier(0.77,0,0.175,1)",transform:on?"translateY(0)":"translateY(110%)",transitionDelay:delay+"ms"}}>
        {children}
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────
   MEDIA RECOGNITION SECTION
   Showcases the Carnival Castle x Kanactify
   PR journey poster — "From Private Theaters to The Tribune"
───────────────────────────────────────────────── */

const MediaRecognitionSection = () => {
  return (
    <section id="media-feature" className="mrsec">
      <style>{`
        .mrsec{
          padding:120px 44px;
          max-width:1280px;
          margin:0 auto;
        }
        .mrhd{text-align:center;margin-bottom:56px}
        .mrhd h2{
          font-family:var(--serif);
          font-size:clamp(32px,4vw,54px);
          line-height:1.1;
          font-weight:900;
          margin-top:14px;
        }
        .mrhd p{
          font-size:16px;
          color:var(--muted);
          max-width:560px;
          margin:16px auto 0;
          line-height:1.85;
        }
        .mrframe{
          border-radius:28px;
          overflow:hidden;
          border:1px solid var(--border);
          box-shadow:0 40px 100px rgba(248,108,61,.12),0 8px 32px rgba(0,0,0,.08);
        }
        .mrframe img{
          width:100%;
          height:auto;
          display:block;
        }
        @media(max-width:768px){
          .mrsec{padding:72px 20px}
          .mrhd{margin-bottom:36px}
          .mrframe{border-radius:18px}
        }
      `}</style>

      <div className="mrhd">
        <RevealContent>
          <div className="ptag">Featured Story</div>
        </RevealContent>
        <RevealLine delay={100}>
          <h2>
            From Private Theaters to <span className="gto">The Tribune</span>
          </h2>
        </RevealLine>
        <RevealContent delay={200}>
          <p>
            A milestone PR campaign for Carnival Castle Private Theatres —
            crafted by Kanactify, turning everyday celebrations into
            headline-worthy media coverage across Hyderabad.
          </p>
        </RevealContent>
      </div>

      <RevealContent delay={300}>
        <div className="mrframe">
          <img
            src={kanactifyCarnivalPoster}
            alt="Kanactify PR journey for Carnival Castle Private Theatres — from private theaters to The Tribune feature"
          />
        </div>
      </RevealContent>
    </section>
  );
};

export default MediaRecognitionSection;